import React, { useEffect, useState, useCallback } from "react";
import { Flex, Box, Text } from "ui-components";
import get from "lodash/get";
import ActivateSuccess from "assets/images/activate-success.png";
import FormattedMessage from "components/FormattedMessage";
import { clearLocalStorage } from "utils/localStorage";
import Video from "components/Video";

const PaymentSuccess = ({ appSettings }) => {
  const [showVideo, setShowVideo] = useState(false);
  const { video_url, close_icon, bill_info_img } =
    get(appSettings, "bill_education") || {};

  setTimeout(() => {
    clearLocalStorage();
  }, 1000);

  const videoHandler = useCallback(
    event => {
      if (event.target.className === "video_container") return;
      if (showVideo) {
        setShowVideo(false);
      }
    },
    [showVideo]
  );

  useEffect(
    () => {
      window.addEventListener("click", videoHandler);
      return () => {
        window.removeEventListener("click", videoHandler);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showVideo, videoHandler]
  );

  const hidePlayer = () => setShowVideo(false);

  const showPlayer = () => setShowVideo(true);
  return (
    <Box data-testid="payment-success" pt="4" variant="main" padding={[4, 6]}>
      <Flex justifyContent="center">
        <img src={ActivateSuccess} alt="success" style={{ height: 300 }} />
      </Flex>

      <Text>
        <FormattedMessage html id="sim_activation_payment_return_message" />
      </Text>

      {showVideo && video_url && (
        <Video
          closeIcon={close_icon}
          videoUrl={video_url}
          hidePlayer={hidePlayer}
          styles={{
            position: "fixed",
            transform: "translate(-50% ,-50%)",
            width: "90%",
            zIndex: 500,
            left: "50%",
            top: "50%"
          }}
        />
      )}
      {bill_info_img && video_url && (
        <Flex
          className="text-md"
          mt={8}
          sx={{ margin: "0 auto", width: "90%" }}
        >
          <Box>
            <img
              src={bill_info_img}
              alt="success"
              style={{ height: 50, width: 60 }}
            />
          </Box>
          <Box width={1} style={{ paddingLeft: 16, lineHeight: 1.5 }}>
            <FormattedMessage html id="first_bill_info_title" />
            <div
              className="video_container"
              onClick={showPlayer}
              style={{
                color: "purple",
                cursor: "pointer",
                textDecoration: "underline"
              }}
            >
              <FormattedMessage html id="click_watch_video" />
            </div>
          </Box>
        </Flex>
      )}
    </Box>
  );
};

export default PaymentSuccess;
